// src/components/tables/IndeterminateCheckbox.tsx
import React, { forwardRef, useRef, useEffect } from 'react';

type IndeterminateCheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  indeterminate?: boolean;
};

export const IndeterminateCheckbox = forwardRef<HTMLInputElement, IndeterminateCheckboxProps>(
  function IndeterminateCheckbox({ indeterminate, ...rest }, forwardedRef) {
    // Store the DOM node in a local ref
    const localRef = useRef<HTMLInputElement | null>(null);

    // Whenever the `indeterminate` prop changes, set the property on our <input>
    useEffect(() => {
      if (localRef.current) {
        localRef.current.indeterminate = !!indeterminate;
      }
    }, [indeterminate]);

    return (
      <input
        type="checkbox"
        {...rest}
        ref={(node) => {
          // Update our local ref
          localRef.current = node;

          // Also, pass it out to the parent if needed
          if (!forwardedRef) return;
          if (typeof forwardedRef === 'function') {
            forwardedRef(node);
          } else {
            // For a standard object ref
            forwardedRef.current = node;
          }
        }}
      />
    );
  }
);
